import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "../../node_modules/react-builder/dist/widgets/BaseComponent";
import { ContainerAttributes } from "../../node_modules/react-builder/dist/widgets/Container";

@AttributeGroup({ title: 'SubmitButton', blockName: 'SubmitButton' })
export class SubmitButtonAttributes extends Attribute {

    @AttributeProperty({ type: 'Object', cssTarget: '' })
    container: ContainerAttributes = new ContainerAttributes().fromJSON({
        background: {
            color: 'red'
        }
    })
}

const SubmitButtonTheme = styled.button((props: { attributes: SubmitButtonAttributes }) => `

    ${props.attributes.toCSS()}

`);

export function SubmitButton(props: ComponentProps<SubmitButtonAttributes>) {
    return (
        <SubmitButtonTheme {...props} attributes={props.attributes}>
            {props.children}
        </SubmitButtonTheme>
    )
}


SubmitButton.prototype.Props = SubmitButtonAttributes;


export default SubmitButton;